import { useContext } from "react";
import { BrandContext } from "./BrandContext";
import { findKeyInObj } from "../../utils/object";

export default function useBrandProp(key: string) {
  const ctx = useContext(BrandContext);
  if (ctx) {
    return findKeyInObj(ctx, key);
  }
  return undefined;
}
